import React, {FC, useCallback, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import url from 'url';
import {ProcessType} from '../../../api/settings/alert_alarm';
import ListSelectFilter from '../../common/ListSelectFilter';
import {
  PROCESS_SORTING_NAMES,
  PROCESS_SORTING_OPTIONS,
  PROCESS_SORTING_QUERY_PARAMS,
  SCHEDULING_PROCESSES_QUICK_FILTERS
} from '../../../constants/constants';
import {OptionsProp} from '../../../constants/types';

type FiltersProps = {
  query: Dictionary<string>,
  pathname: string,
  isLoading: boolean,
  typeOptions: OptionsProp[]
}

const Filters: FC<FiltersProps> = ({
  query, pathname, isLoading, typeOptions
}) => {
  const history = useHistory();
  const {t} = useTranslation('processes');

  const pushToUrl = useCallback((newValues) => {
    history.push(
        url.format({
          pathname,
          query:
          {
            ...query,
            ...newValues
          }
        }));
  }, [query, pathname]);

  const handleChangeType = useCallback((value) => {
    pushToUrl({
      type: value,
      quick_filter: 'ALL'
    });
  }, [pushToUrl]);

  const handleChangeSorting = useCallback((value) => {
    pushToUrl(PROCESS_SORTING_QUERY_PARAMS[value]);
  }, [pushToUrl]);

  const sortingValue = useMemo(() => {
    if (query.sort !== 'patient') return;

    if (query.direction === 'desc') {
      return PROCESS_SORTING_NAMES.patientDesc;
    }

    return PROCESS_SORTING_NAMES.patientAsc;
  }, [query.sort, query.direction]);

  return (
    <div className="running-processes_selects">
      {query.type === ProcessType.SCHEDULING && (
        <ListSelectFilter
          options={SCHEDULING_PROCESSES_QUICK_FILTERS}
          name="quick_filter"
          disabled={isLoading}
          label={t('processListFilters.quickFilter')}
          query={query}
        />
      )}

      <ListSelectFilter
        options={typeOptions}
        name="type"
        disabled={isLoading}
        label={t('processListFilters.type')}
        query={query}
        onChange={handleChangeType}
      />

      <ListSelectFilter
        name="sortBy"
        label={t('processListFilters.sort')}
        options={PROCESS_SORTING_OPTIONS}
        query={query}
        disabled={isLoading}
        onChange={handleChangeSorting}
        customValue={sortingValue}
      />
    </div>
  );
};

export default Filters;
